import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Languages } from 'lucide-react';

interface LanguageSelectorProps {
  value: string;
  onChange: (language: string) => void;
}

export function LanguageSelector({ value, onChange }: LanguageSelectorProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Languages className="w-5 h-5" />
          Interview Language
        </CardTitle>
        <CardDescription>
          Choose the language for the interview questions and briefing
        </CardDescription>
      </CardHeader>
      <CardContent>
        <RadioGroup value={value} onValueChange={onChange}>
          <div className="flex items-center space-x-2 mb-3">
            <RadioGroupItem value="en" id="lang-en" />
            <Label htmlFor="lang-en" className="cursor-pointer flex items-center gap-2">
              <span className="text-2xl">🇬🇧</span>
              <div>
                <div className="font-medium">English</div>
                <div className="text-sm text-muted-foreground">
                  Interview will be conducted in English
                </div>
              </div>
            </Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="es" id="lang-es" />
            <Label htmlFor="lang-es" className="cursor-pointer flex items-center gap-2">
              <span className="text-2xl">🇪🇸</span>
              <div>
                <div className="font-medium">Español (Spanish)</div>
                <div className="text-sm text-muted-foreground">
                  La entrevista se realizará en español
                </div>
              </div>
            </Label>
          </div>
        </RadioGroup>
      </CardContent>
    </Card>
  );
}
